import {Camera, Scene, vec3, Texture, Renderer, Container} from './beam/index';
import RenderPipeline from './beam-engine/index.js'
import GPGPUParticles from './beam-engine/gpgpu-particles'
import UE4Loader from './beam-engine/loaders/UE4Loader'
import settings, {debugData, updateProfile, getProfile} from './beam-engine/settings';
import MinimalGLTFLoader from './beam-engine/loaders/MinimalGLTFLoader';
import stats from './stats';

const PIXEL_RATIO  = 1;

let diff = vec3.create();
let cameraDir = vec3.create();

function nestedEach(obj, callback, lvl) {
    if (!obj) {
        return
    }
    lvl = lvl || 0;
    callback( obj, lvl )
    obj.children && obj.children.forEach((child)=>{
        nestedEach( child, callback, lvl+1 )
    });
}


export default class GLScene {
 

    constructor(el) {

        this.el = el;

        this.data = {
            cdn: el.getAttribute('cdn'),
            playing: true,
        }

        this.$canvas = document.createElement('canvas')
        this.el.appendChild(this.$canvas);

        this.$glStats = document.createElement('gl-stats-old');
        this.$glStats.style.position = 'absolute';
        this.$glStats.style.bottom = 0;
        this.$glStats.style.left = 0;
        this.el.appendChild(this.$glStats);
        
        let options = {}
        options.hdr = ""
        options.noise = "assets/noise/bluenoise-64-RG01/LDR_RG01_0.png"
        options.cdn = this.data.cdn
        options.lobby_reflection_map = "assets/textures/lobby_reflection_map.png"
        this.options = options;

        this.cameraProgress   = 0;
        this.smoothedProgress = 0;
        this.speed            = 0;

        this.renderer = new Renderer({
            canvas:     this.$canvas,
            alpha:      false,
            derivative: true,
            antialias:  false,
            powerPreference: 'high-performance',
            stencil:   false,
        });
        this.renderer.gl.getExtension('OES_standard_derivatives');

        this.loadedScenes = {}

        this.lobbyVideos          = [];
        this.officeVideos         = [];
        this.circularcenterVideos = [];
        this.quantumroomVideos    = [];
        

        this.introZoomProgress = 0;
        this.cameraProgress          = 0;
        this.currCameraProgress          = 0;

        this.createCameras();
        this.createRenderPipeline();
        // this.createMenuScene();
    }

    updateProfile(mode) {
        updateProfile(settings, mode);
        this.useScene(this.currentSceneName, ()=>{}, true);
    }

    getProfile() {
        return getProfile();
    }

    buildLobbyVideoTexture() {
        for (let i=0; i<1; i++) {
            if (window.innerWidth > 850) {
                let video = document.createElement('video') ;
                video.autoplay = true
                video.loop     = true
                video.width    = 512
                video.height   = 512
                video.muted    = true
                video.setAttribute('playsinline', true)
                video.setAttribute('muted', true)
                video.src      = 'assets/video/lobby_person_'+i+'.mp4';
                let texture = new Texture(this.renderer.gl, {
                    linear:     true, 
                    mipmap:     true, 
                    miplinear:  true,
                    flipY:      false,
                    wrapS:      this.renderer.gl.REPEAT,
                    wrapT:      this.renderer.gl.REPEAT,
                    anisotropy: 0,
                });
                video.play()
                texture.bindImage( video )
                this.lobbyVideos.push( {
                    video,
                    texture
                });
            }
            else {
                let image = new Image()
                image.onload = e => {
                    console.log('LOADED', 'assets/video/lobby_person_'+i+'.jpg');
                }
                image.src = 'assets/video/lobby_person_'+i+'.jpg';
                let texture = new Texture(this.renderer.gl,{
                    linear:     false, 
                    mipmap:     false, 
                    miplinear:  true,
                    flipY:      false,
                    wrapS:      this.renderer.gl.REPEAT,
                    wrapT:      this.renderer.gl.REPEAT,
                    anisotropy: 0,
                });
                this.lobbyVideos.push( {
                    image,
                    texture
                });
            }
        }
    }

    buildOfficeVideoTexture() {
        for (let i=0; i<4; i++) {
            if (window.innerWidth > 850) {
                let video = document.createElement('video') 
                video.autoplay = true
                video.loop     = true
                video.width    = 512
                video.height   = 512
                video.muted    = true
                video.setAttribute('playsinline', true)
                video.setAttribute('muted', true)
                video.src      = 'assets/video/office_person_'+i+'.mp4'
                let texture = new Texture(this.renderer.gl, {
                    linear:     true, 
                    mipmap:     true, 
                    miplinear:  true,
                    flipY:      false,
                    wrapS:      this.renderer.gl.REPEAT,
                    wrapT:      this.renderer.gl.REPEAT,
                    anisotropy: 0,
                });
                video.play()
                texture.bindImage( video )
                this.officeVideos.push( {
                    video,
                    texture
                } )
            }
            else {
                console.log('NEW PERSON TEXTURE')
                let image = new Image()
                image.onload = e => {
                    console.log('LOADED', 'assets/video/office_person_'+i+'.jpg')
                }
                image.src = 'assets/video/office_person_'+i+'.jpg'
                let texture = new Texture(this.renderer.gl,{
                    linear:     false, 
                    mipmap:     false, 
                    miplinear:  true,
                    flipY:      false,
                    wrapS:      this.renderer.gl.REPEAT,
                    wrapT:      this.renderer.gl.REPEAT,
                    anisotropy: 0,
                });
                this.officeVideos.push( {
                    image,
                    texture
                } )
            }
        }
    }

    buildquantumroomVideoTexture() {
        for (let i=0; i<2; i++) {
            if (window.innerWidth > 850) {
                let video = document.createElement('video') 
                video.autoplay = true
                video.loop     = true
                video.width    = 512
                video.height   = 512
                video.muted    = true
                video.setAttribute('playsinline', true)
                video.setAttribute('muted', true)
                video.src      = 'assets/video/quantumroom_person_'+i+'.mp4'
                let texture = new Texture(this.renderer.gl, {
                    linear:     true, 
                    mipmap:     true, 
                    miplinear:  true,
                    flipY:      false,
                    wrapS:      this.renderer.gl.REPEAT,
                    wrapT:      this.renderer.gl.REPEAT,
                    anisotropy: 0,
                });
                video.play()
                texture.bindImage( video )
                this.quantumroomVideos.push( {
                    video,
                    texture
                } )
            }
            else {
                console.log('NEW PERSON TEXTURE')
                let image = new Image()
                image.onload = e => {
                    console.log('LOADED', 'assets/video/quantumroom_person_'+i+'.jpg')
                }
                image.src = 'assets/video/quantumroom_person_'+i+'.jpg'
                let texture = new Texture(this.renderer.gl,{
                    linear:     false, 
                    mipmap:     false, 
                    miplinear:  true,
                    flipY:      false,
                    wrapS:      this.renderer.gl.REPEAT,
                    wrapT:      this.renderer.gl.REPEAT,
                    anisotropy: 0,
                });
                this.quantumroomVideos.push( {
                    image,
                    texture
                } )
            }
        }
    }

    buildCircularCenterVideoTexture() {
        for (let i=0; i<4; i++) {
            if (window.innerWidth > 850) {
 
                let video = document.createElement('video') 
                video.autoplay = true
                video.loop     = true
                video.width    = 512
                video.height   = 512
                video.muted    = true
                video.setAttribute('playsinline', true)
                video.setAttribute('muted', true)
                video.src      = 'assets/video/circularcenter_person_'+i+'.mp4?v=2'
                let texture = new Texture(this.renderer.gl, {
                    linear:     true, 
                    mipmap:     true, 
                    miplinear:  true,
                    flipY:      false,
                    wrapS:      this.renderer.gl.REPEAT,
                    wrapT:      this.renderer.gl.REPEAT,
                    anisotropy: 0,
                });
                video.play()
                texture.bindImage( video )
                this.circularcenterVideos.push( {
                    video,
                    texture
                } )
            }
            else {
                console.log('NEW PERSON TEXTURE')
                let image = new Image()
                image.onload = e => {
                    console.log('LOADED', 'assets/video/circularcenter_person_'+i+'.jpg')
                }
                image.src = 'assets/video/circularcenter_person_'+i+'.jpg'
                let texture = new Texture(this.renderer.gl,{
                    linear:     false, 
                    mipmap:     false, 
                    miplinear:  true,
                    flipY:      false,
                    wrapS:      this.renderer.gl.REPEAT,
                    wrapT:      this.renderer.gl.REPEAT,
                    anisotropy: 0,
                });
                this.quantumroomVideos.push( {
                    image,
                    texture
                } )
            }
        }
    }

    createCameras() {

        this.cameraRotationY = 0

        // this.menuCamera = new Camera({
        //     aspect:            window.innerWidth / window.innerHeight,
        //     near:              1,
        //     far:               8000.0,
        //     fov:               15,
        //     type:              'perspective',
        //     orbitControl:      true,
        //     cameraDistance:    1500,
        //     wheelSpeed:        0.1,
        //     moveSpeed:         100,
        //     position:          [0, 0, 0],
        //     lookAt:            [0,0,0],
        //     offset:            [50,0,0],
        //     frustum:           true,
        //     phi:               0.45,
        //     theta:             0.7,
        //     minCameraDistance: 1500,
        //     maxCameraDistance: 3000,
        // });
        // this.menuCamera.disable();

        this.camera = new Camera({
            aspect:        window.innerWidth / window.innerHeight,
            near:          50,
            far:           8000,
            fov:           45,
            type:          'perspective',
            lookAround:    !settings.debugCamera,
            firstPerson:   settings.debugCamera,
            playerCamera:  settings.usePlayerCamera,
            lookAt:        [0,0,0],
            wheelSpeed:    0.1,
            minPhi:        0,
            moveSpeed:     settings.debugCamera ? 50 : 50,
            position:      settings.debugCamera ? [0, 200, -1500] : [0, 1000, 0],
            frustum:       true,
        });
        this.camera.lookAt = vec3.create()


        this.quantumCamera = new Camera({
            aspect:        window.innerWidth / window.innerHeight,
            near:          50,
            far:           8000,
            fov:           60,
            type:          'perspective',
            lookAround:    !settings.debugCamera,
            firstPerson:   settings.debugCamera,
            playerCamera:  settings.usePlayerCamera,
            lookAt:        [0,0,0],
            wheelSpeed:    0.1,
            minPhi:        0,
            moveSpeed:     settings.debugCamera ? 50 : 50,
            position:      settings.debugCamera ? [0, 200, -1500] : [0, 1000, 0],
            frustum:       true,
        });
        this.quantumCamera.lookAt = vec3.create();
        

        this.officeCamera = new Camera({
            aspect:        window.innerWidth / window.innerHeight,
            near:          100,
            far:           8000,
            fov:           45,
            type:          'perspective',
            lookAround:    !settings.debugCamera,
            firstPerson:   settings.debugCamera,
            playerCamera:  settings.usePlayerCamera,
            lookAt:        [0,0,0],
            wheelSpeed:    0.1,
            minTheta:     -0.8,//-Math.PI,//right
            maxTheta:      0.35,//left
            moveSpeed:     settings.debugCamera ? 50 : 50,
            position:      settings.debugCamera ? [0, 200, -1500] : [0, 1000, 0],
            frustum:       true,
        });
        this.officeCamera.lookAt = vec3.create()



        this.operationCamera = new Camera({
            aspect:        window.innerWidth / window.innerHeight,
            near:          50,
            far:           10000000,
            fov:           45,
            type:          'perspective',
            lookAround:    !settings.debugCamera,
            firstPerson:   settings.debugCamera,
            playerCamera:  settings.usePlayerCamera,
            lookAt:        [0,0,0],
            wheelSpeed:    0.01,
            moveSpeed:     100,
            frustum:        true,
            position:      [0, 0, 200],
        });
        this.operationCamera.lookAt = vec3.create()

        this.innovationCamera = new Camera({
            aspect:        window.innerWidth / window.innerHeight,
            near:          50,
            far:           1000000,
            fov:           45,
            type:          'perspective',
            lookAround:    !settings.debugCamera,
            firstPerson:   settings.debugCamera,
            playerCamera:  settings.usePlayerCamera,
            lookAt:        [0,0,0],
            wheelSpeed:    0.01,
            moveSpeed:     100,
            frustum:        true,
            position:      [0, 0, 200],
        });
        this.innovationCamera.lookAt = vec3.create()


        this.circularCenterCamera = new Camera({
            aspect:        window.innerWidth / window.innerHeight,
            near:          50,
            far:           1000000,
            fov:           45,
            type:          'perspective',
            lookAround:    !settings.debugCamera,
            firstPerson:   settings.debugCamera,
            playerCamera:  settings.usePlayerCamera,
            lookAt:        [0,0,0],
            wheelSpeed:    0.01,
            moveSpeed:     100,
            frustum:        true,
            // minTheta:     -0.8,//-Math.PI,//right
            // maxTheta:      0.35,//left
            position:        [0, 0, 200],
            cameraTiltTheta: 0.2,
            cameraTiltPhi:   0.05,
        });
        this.circularCenterCamera.lookAt = vec3.create()

 
        this.homeCamera = new Camera({
            aspect:            window.innerWidth / window.innerHeight,
            near:              500,
            far:               12000.0,
            fov:               15,
            type:              'perspective',
            tilt:              !settings.debugCamera,
            orbitControl:      settings.debugCamera,
            cameraDistance:    4000,
            wheelSpeed:        0.1,
            moveSpeed:         100,
            position:          [0, 0, 4000],
            lookAt:            settings.debugCamera ? [0,0,0] : [500,400,1000],
            frustum:           true,
            phi:               0.45,
            drag:              false,
            theta:             0.7,
            minCameraDistance: settings.debugCamera ? 0 : 900,//1000,
            maxCameraDistance: settings.debugCamera ? 10000 : 4000,
        });
        this.homeCamera.name = 'orbit'

        this.focusCamera =     this.focusCamera || new Camera({
            aspect:            window.innerWidth / window.innerHeight,
            near:              10,
            far:               5000,//10000000000000,//8000.0,
            fov:               75,
            type:              'perspective',
            orbitControl:      true,
            lookAt:            [0,0,0],
            phi:               0.,
            theta:             Math.PI/2,
            wheelSpeed:        0.1,
            moveSpeed:         50,
            offset:            [-150,110,-10],
            position:          [0, 100, 0],
            frustum:           true,
            cameraDistance:    130,
            minCameraDistance: 50,
            maxCameraDistance: 130,
        });
        this.focusCamera.name = 'orbit'




        let w = window.innerWidth
        let h = window.innerHeight
        
        this.camera.aspect  = w/h
        this.camera.updateProjectionMatrix()

        this.operationCamera.aspect  = w/h
        this.operationCamera.updateProjectionMatrix()

        this.focusCamera.aspect = w/h
        this.focusCamera.updateProjectionMatrix()
    }

    destroy() {
        this.camera?.destroy()
        this.operationCamera?.destroy()
        this.innovationCamera?.destroy()
        this.circularCenterCamera?.destroy()
        this.officeCamera?.destroy()
        this.officeCamera?.destroy()
        this.homeCamera?.destroy()
        this.quantumCamera?.destroy()
        document.removeEventListener("keydown", this.onKeyDown, false);
        document.removeEventListener("keyup", this.onKeyUp, false);
    }

    createRenderPipeline() {
        this.renderPipeline && this.renderPipeline.destroy()
        this.renderPipeline = new RenderPipeline({
            lobby_reflection_map:  this.options.lobby_reflection_map,
            noise:                 this.options.noise,
            hdr:                   this.options.hdr,
            renderer:              this.renderer,
            camera:                this.operationCamera,
            resolution:            [window.innerWidth, window.innerHeight],
            beforeShadowPass:      ()=> {},
            beforeDepthPass:       ()=> {},
            beforeDepthPass:       () =>{},
            beforeMainPass:        ()=> {},
            afterMainPass:         ()=> {},
            onRenderPass:          (passes)=> {
                this.fire('renderpass', passes)
            },
        })
    }


    // openMenuScene() {
    //     this.menuCamera.enable()
    //     this.isMenuOpened = true;
    //     this.useScene('menu', null, true);
    // }

    // closeMenuScene() {
    //     this.menuCamera.disable()
    //     this.isMenuOpened = false;
    //     this.useScene(this.currentSceneName, null, true);
    // }

    // createMenuScene() {

    //     this.menuScene = new Scene()
    //     this.menuScene.name = 'menu';
    //     this.menuScene.id   = 'menu';

    //     if (settings.profile <= 0) {
    //         document.body.classList.add('profile-0')
    //         return
    //     }

    //     document.body.classList.remove('profile-0');

    //     this.menuScene.uiElements = [];
    //     let itemPositions = [
    //         [  210,  10,  30 ],
    //         [  150,  10,  30 ],
    //         [   50,  10, -90 ],
    //         [  -10,  10,  15 ],
    //         [ -120,  10, -40 ],
    //         [ -60,  10,  -90 ],
    //         [ -200,  10,  -300 ],
    //         [ 180,  10, -50  ],
    //     ]
    //     for (let i=0; i<itemPositions.length; i++) {
    //         let uiMesh = new Container();
    //         uiMesh.id = 'MENU_ITEM_' + i;
    //         uiMesh.position =  [itemPositions[i][0], itemPositions[i][1], itemPositions[i][2]]
    //         this.menuScene.uiElements.push( uiMesh )
    //     }

    //     var glTFLoader = new MinimalGLTFLoader();
    //     glTFLoader.loadGLTF('assets/gltf/menu.draco.gltf', glTF => {

    //         let COLORS = [
    //             [129./255.,197./255.,226./255.],
    //             [ 0, 1, 0 ],
    //             [ 0, 0, 1 ],
    //             [ 1, 1, 0 ],
    //             [ 0, 1, 1 ],
    //             [ 254/255, 209/255, 10/255 ],
    //             [ 254/255, 209/255, 10/255 ]
    //         ]

    //         let particleMeshes = []
    //         for (let i=0; i<glTF.meshes.length; i++) {
    //             let mesh = glTF.meshes[i];
    //             let positions = []
    //             let color = COLORS[(i)%COLORS.length]
    //             for (let j=0; j<mesh.primitives.length; j++) {
    //                 let idx = mesh.primitives[j].indices
    //                 let pos = mesh.primitives[j].attributes.POSITION
    //                 for (let i=0; i<idx.length; i++) {
    //                     positions.push( pos[ idx[i] * 3 ], pos[ idx[i]*3 +1 ], pos[ idx[i]*3 + 2 ] )
    //                 }
    //             }
    //             particleMeshes.push({ positions, color })
    //         }

    //         this.menuParticles = new GPGPUParticles(this.renderer, {
    //             meshes: particleMeshes,
    //             profile: settings.profile
    //         });

    //         this.menuScene.add( this.menuParticles.lineMesh );

    //         let _menuScene = {
    //             name: 'menu',
    //             gltf:  glTF,
    //             json: null,
    //             ue4:{
    //                 root: this.menuScene,
    //                 cache: {
    //                     materials: {},
    //                     meshes: {},
    //                 },
    //                 options: {
    //                     name:             'menu',
    //                     gltf:             'assets/gltf/menu.draco.gltf',
    //                     json:              null,
    //                     textureDir:        null,
    //                     textureResolution: null,
    //                     particleSystem:    null,
    //                     mipmap:            null,
    //                     left:              null,
    //                     right:             null,
    //                     top:               null,
    //                     bottom:            null,
    //                     near:              null,
    //                 }
    //             }
    //         }
    //         this.loadedScenes['menu'] = _menuScene;
    //     });
    // }
    
    focusObject(index) {
        if (this.focusableObjects) {
            this.isFocusMode = true
            this.focusableObjects.forEach((oject, i)=>{
                for (let p in oject) {
                    oject[p].visible = i == index;
                    if (p == 'TopPanel' || p == 'Top_Panel') {
                        oject[p].visible = false;
                    }
                }
            })
            this.renderPipeline.useCamera(this.focusCamera)
            this.renderPipeline.setVignetting( true, [0,0,0], 0.9 )
        }
    }

    unfocusObject() {
        this.isFocusMode = false;
        this.renderPipeline.useCamera(this.currentCamera)
        if (this.focusableObjects) {
            this.focusableObjects.forEach((object, i)=>{
                for (let p in object) {//parts/primitives
                    object[p].visible = false;
                }
            })
        }
        this.renderPipeline.setVignetting( true, [0,0,0], 0.1 )
    }

    enterInnerRoom() {
        // this.renderPipeline.useCamera(this.serverInnerCamera);
        this.isInSubRoom = true;
        this.cameraRotationY = 0;
        window.scrollTo(0,0);
        this.cameraProgress          = 0;
        if (this.camera) {
            this.camera.currTheta        = 0;
            this.camera.theta            = 0;
            this.camera.currPointerTheta = 0;
            this.camera.pointerTheta     = 0;
        }
    }

    leaveInnerRoom() {
        // this.renderPipeline.useCamera(this.camera);
        this.isInSubRoom = false;
        this.cameraRotationY = 0;
        window.scrollTo(0,0);
        this.cameraProgress          = 0;
        if (this.camera) {
            this.camera.currTheta        = 0;
            this.camera.theta            = 0;
            this.camera.currPointerTheta = 0;
            this.camera.pointerTheta     = 0;
        }
    }

    async loadScene(jsonUrl) {
        this.loadedScenes = {};
        this.renderPipeline?.clearCache();
        this.renderPipeline.scene = null;

        const res = await fetch(jsonUrl);
        if (!res.ok) {
            throw new Error(`Failed to load scene JSON: ${res.status} ${res.statusText}`);
        }

        const json = await res.json();
        const { gltf_url: gltfUrl, scene_name: name } = json;

        const finalGltfUrl = settings.useDraco
            ? gltfUrl.replace('.gltf', '.draco.gltf')
            : gltfUrl;

        const loadedGltf = await new Promise((resolve, reject) => {
            const loader = new MinimalGLTFLoader();
            try {
                loader.loadGLTF(finalGltfUrl, resolve);
            } catch (err) {
                reject(err);
            }
        });

        this.buildUE4Scene(name, loadedGltf, json);
        return name;
    }

    buildUE4Scene(name, loadedGltf, loadedJSON) {

        let opt = {
            textureResolution:    null,
            particleSystem:       false,
            mipmap:               true,
            left:    ( -7000 * 0.1),
            right:   (  7000 * 0.1),
            top:     (  6000 * 0.1),
            bottom:  ( -15000 * 0.1),
            near:   1,
        }
        if ( name=='exterior' ){
            opt.textureResolution  = '2048'
            opt.mipmap = false;
        }
        if ( name=='operationroom' ){
            opt.particleSystem = true;
        }

        let ue4Scene = {
            gltf: loadedGltf,
            json: loadedJSON,
            ue4: new UE4Loader( this.renderer.gl, {
                name,
                'gltf':            loadedGltf,
                'json':            loadedJSON,
                'textureDir':      `${ this.options.cdn }assets/textures/${name}/`,
                textureResolution: opt.textureResolution,
                particleSystem:    opt.particleSystem,
                mipmap:            opt.mipmap,
                left:              opt.left,
                right:             opt.right,
                top:               opt.top,
                bottom:            opt.bottom,
                near:              opt.near,
            })
        }
        ue4Scene.name = name;
        this.loadedScenes[name] = ue4Scene;
    }

    useScene(name, cb, skip) {


      

        if (name != 'menu') {
            this.currentCamera = this.camera;
            if (!skip) {
                this.currentSceneName = name;
                this.cameraRotationY     = 0
                this.cameraSpeed         = 0.0002
                this.introZoomProgress   = 0;
                this.cameraProgress      = 0;
            }
        }
        
        let sceneOptions = {
            cloudsBeforeTAA:           false,
            useChromaticAberration:    true,
            chromaticAberrationOffset: 4,
            useFog:                    false,
            focalLength:               2.400001,
            skySphereRadus:            5000,
            lightSize:                 settings.uLightSize,
            sceneDownscale:            1,
            useClouds:                 false,
            useSSGI:                   true,
            useSSR:                    true,
            useSSAO:                   true,
            useSSDirect:               true,
            useUnjitter:               true,
            useVignetting:             true,
            vignettingColor:           [0,0,0],
            vignettingStrength:        0.1,
            useToneMapping:            true,
            ShadowMapSize:             512,
            ShadowMapBias:             settings.profile == 0 ? 0.0005 : 0.0001,
            useIBL:                    false,
            useSky:                    false,
            useHDR:                    false,
            useBloom:                  false,
            useColorCorrection:        false,
            uContrast:                 1.1,
            uSaturation:               1.05,
            uRed:                      0.502,
            uGreen:                    0.499,
            uBlue:                     0.503,
            IBLDiffuseMix:             1,
            IBLSpecularMix:            1,
            blurHDR:                   false,
            useSoftShadows:            true,
            skySphereColor:            [177./255., 185./255., 198./255.],

            useCenterShadows: true,

            useAmbientLight: false,
            uAmbientLight:   [0,0,0],
        }


        // if ( name=='menu' ){
        //     this.currentCamera          = this.menuCamera
        //     sceneOptions.focalLength               = 7.2
        //     sceneOptions.useToneMapping            = false;
        //     sceneOptions.useBloom                  = true
        //     sceneOptions.vignettingStrength        = 1;
        //     sceneOptions.chromaticAberrationOffset = 20;
        // }

        if (name == 'lobby') {
            sceneOptions.useColorCorrection = true
            sceneOptions.uContrast   = 1.1
            sceneOptions.uSaturation = 1.05
            sceneOptions.uRed        = 0.502
            sceneOptions.uGreen      = 0.499
            sceneOptions.uBlue       = 0.503
            this.loadedScenes[ name ].ue4.root.position[1] = 8;
        }
        if ( name=='networkroom' ){
            sceneOptions.useColorCorrection = true
            sceneOptions.uBrightness        = 0.1
            sceneOptions.uContrast          = 1.3
            sceneOptions.uSaturation        = 1.
            sceneOptions.uRed               = 0.5
            sceneOptions.uGreen             = 0.5
            sceneOptions.uBlue              = 0.509
        }

        if ( name=='circularcenter' ){
            sceneOptions.useColorCorrection = true
            sceneOptions.uBrightness        = 0.06
            sceneOptions.uContrast          = 1.1
            sceneOptions.uSaturation        = 1.1
            sceneOptions.uRed               = 0.5
            sceneOptions.uGreen             = 0.5
            sceneOptions.uBlue              = 0.505
            sceneOptions.useCenterShadows = false;
        }
        
        if ( name=='serverroom' ){
            sceneOptions.useColorCorrection = true
            sceneOptions.uBrightness        = 0.06
            sceneOptions.uContrast          = 1.1
            sceneOptions.uSaturation        = 1.1
            sceneOptions.uRed               = 0.5
            sceneOptions.uGreen             = 0.5
            sceneOptions.uBlue              = 0.505
            sceneOptions.useCenterShadows   = false;
            let servers = {}
            this.focusableObjects = []
            nestedEach(this.loadedScenes[ name ].ue4.root, (node)=>{
                if (   /SM\_Server0/.test(node.id)
                    && !/Primitive/.test(node.id)
                ){
                    let serverName = node.id.replace(/(SM\_Server[0-9]+).+/, (a,b,c)=>{ return b; })
                    let partName   = node.id.replace(serverName+'_', '').replace(/\_[0-9]+$/,'')
                    servers[serverName] = servers[serverName] || {}
                    servers[serverName][partName] = node;
                }
            })
            for (let k in servers) {
                this.focusableObjects.push( servers[k] )
            }
            if (this.focusableObjects) {
                this.focusableObjects.forEach((server, i)=>{
                    for (let p in server) {
                        server[p].visible = false
                        server[p].children[0].rotation[0] = Math.PI/2 - 0.6;
                        server[p].children[0].rotation[1] = 0.5;
                        if (p == 'TopPanel' || p == 'Top_Panel') {
                            server[p].visible = false;
                        }
                    }
                })
            }
        }

        if ( name=='exterior' ){
            this.currentCamera                  = this.homeCamera
            sceneOptions.useSSGI                = false;
            sceneOptions.useSSR                 = false;
            sceneOptions.useSSAO                = false;
            sceneOptions.useSSDirect            = false;
            sceneOptions.useClouds              = true
            sceneOptions.mipmap                 = false;
            sceneOptions.useToneMapping         = false;
            sceneOptions.textureResolution      ='2048'
            sceneOptions.focalLength            = 7.2
            sceneOptions.useChromaticAberration = false
            sceneOptions.useColorCorrection     = true;
            sceneOptions.uContrast              = 1.05;
            sceneOptions.uSaturation            = 1.05;
            sceneOptions.uRed                   = 0.5;
            sceneOptions.uGreen                 = 0.5;
            sceneOptions.uBlue                  = 0.5;
            sceneOptions.uCloudsCenter          = [0., 1200, 0.]//0.,5000.,0.
            sceneOptions.uCloudsDownscale       = 0.01// = 0.02,
            sceneOptions.skySphereRadus         = 4000
            sceneOptions.vignettingColor        = [177./255., 185./255., 198./255.];

        }
        if ( name=='operationroom' ){
            this.currentCamera = this.operationCamera
            sceneOptions.useClouds = settings.useCloudsAndParticles ?  true : false;
            sceneOptions.skySphereRadus = 900000
            sceneOptions.sceneDownscale = 0.05//0.8
            sceneOptions.lightSize = 0.0005
            sceneOptions.particleSystem = true;
            sceneOptions.useIBL = true;
            sceneOptions.useBloom = true
            sceneOptions.useSky = true;
            sceneOptions.ShadowMapSize = 2048
            sceneOptions.ShadowMapBias = 0.0008//0.0001//05//0.0005//0.0008
            sceneOptions.useColorCorrection = true
            sceneOptions.uBrightness = 0.06//0.15
            sceneOptions.uContrast = 1.1
            sceneOptions.uSaturation = 1.15//1.4
            sceneOptions.uRed =   0.505//0.51
            sceneOptions.uGreen = 0.499
            sceneOptions.uBlue  =  0.499
            sceneOptions.uCloudsCenter = [0.,4000.,0.]//
            sceneOptions.uCloudsDownscale = 0.001//
            sceneOptions.useFog = true
            sceneOptions.IBLDiffuseMix= 0.3//0.17
            sceneOptions.IBLSpecularMix=0.5//0.5
            sceneOptions.cloudsBeforeTAA = true;
            sceneOptions.vignettingStrength = 0.5;
            this.loadedScenes[ name ].ue4.root.position[1] = -50;
        }
        if ( name=='innovationroom' ){
            this.currentCamera = this.innovationCamera
            sceneOptions.skySphereRadus = 90000
            sceneOptions.useIBL = false;
            sceneOptions.useHDR = false;
            sceneOptions.skySphereColor = [0, 0, 0]
            sceneOptions.useCenterShadows = false;
        }

        if ( name=='circularcenter' ){
            this.currentCamera = this.circularCenterCamera
        }

        if (name=='officeroom') {
            this.currentCamera = this.officeCamera
            sceneOptions.useCenterShadows = false;
        }

        if (name=='quantumroom') {
            this.currentCamera = this.quantumCamera;
            sceneOptions.useColorCorrection = true
            sceneOptions.uBrightness        = 0.06
            sceneOptions.uContrast          = 1.1
            sceneOptions.uSaturation        = 1.1
            sceneOptions.uRed               = 0.5
            sceneOptions.uGreen             = 0.5
            sceneOptions.uBlue              = 0.505
            sceneOptions.useCenterShadows   = false;
            sceneOptions.useAmbientLight    = true;
            sceneOptions.uAmbientLight      = [0.1, 0.1, 0.1];
        }

        if ( name == 'lobby' || name == 'officeroom' || name == 'circularcenter' || name=='quantumroom' ){
            this.lookAtCameraObjects = [];
            nestedEach(this.loadedScenes[ name ].ue4.root, (node)=>{
                if ( /PERSON/g.test(node.id) ) {
                    node.static = false
                    this.lookAtCameraObjects.push( node )
                }
            })
        }

        settings.useAmbientLight  = sceneOptions.useAmbientLight;
        settings.uAmbientLight    = sceneOptions.uAmbientLight;
        settings.useCenterShadows = sceneOptions.useCenterShadows
        settings.cloudsBeforeTAA  = sceneOptions.cloudsBeforeTAA
        settings.focalLength      = sceneOptions.focalLength
        settings.sceneDownscale   = sceneOptions.sceneDownscale
        settings.uBrightness      = sceneOptions.uBrightness
        settings.uContrast        = sceneOptions.uContrast
        settings.uSaturation      = sceneOptions.uSaturation
        settings.uRed             = sceneOptions.uRed
        settings.uGreen           = sceneOptions.uGreen
        settings.uBlue            = sceneOptions.uBlue
        settings.uCloudsCenter    = sceneOptions.uCloudsCenter
        settings.uCloudsDownscale = sceneOptions.uCloudsDownscale

        this.renderPipeline.setSkySphereColor( sceneOptions.skySphereColor )
        this.renderPipeline.setFog( sceneOptions.useFog )
        this.renderPipeline.setChromaticAberration(sceneOptions.useChromaticAberration, sceneOptions.chromaticAberrationOffset)
        this.renderPipeline.setColorcorrection( sceneOptions.useColorCorrection )
        this.renderPipeline.setIBL( sceneOptions.useIBL, sceneOptions.IBLDiffuseMix, sceneOptions.IBLSpecularMix )
        this.renderPipeline.setBloom( sceneOptions.useBloom );
        this.renderPipeline.setSky( sceneOptions.useSky )
        this.renderPipeline.setHDR( sceneOptions.useHDR, sceneOptions.HDRMap, sceneOptions.blurHDR )
        this.renderPipeline.setClouds( sceneOptions.useClouds )

        // console.log('USE_SCENE', sceneOptions.useClouds);

        this.renderPipeline.setSkySphereRadius( sceneOptions.skySphereRadus )
        this.renderPipeline.setShadowMapSize( sceneOptions.ShadowMapSize )
        this.renderPipeline.setShadowMapBias( sceneOptions.ShadowMapBias )
        this.renderPipeline.setLightSize( sceneOptions.lightSize )
        this.renderPipeline.setSSGI(sceneOptions.useSSGI)
        this.renderPipeline.setSSR(sceneOptions.useSSR)
        this.renderPipeline.setSSAO(sceneOptions.useSSAO)
        this.renderPipeline.setSSDirect(sceneOptions.useSSDirect)
        this.renderPipeline.setUnjitter(sceneOptions.useUnjitter)
        this.renderPipeline.setToneMapping( sceneOptions.useToneMapping )
        this.renderPipeline.setVignetting( sceneOptions.useVignetting, sceneOptions.vignettingColor, sceneOptions.vignettingStrength )
        this.renderPipeline.useCamera(this.currentCamera)

        // if (name == 'menu') {
        //     this.renderPipeline.useScene(this.menuScene, skip);
        //     cb && cb();
        // }
        // else {
            if (!skip) {
                this.cameraRotationY   = 0
                this.cameraSpeed       = 0.0002
                this.introZoomProgress = 0;
                this.cameraProgress    = 0;
            }
            const scene = this.loadedScenes[ name ];
            scene.ue4.root.scale[0] =
            scene.ue4.root.scale[1] =
            scene.ue4.root.scale[2] = settings.sceneDownscale;
            this.renderPipeline.useScene( scene.ue4.scene, skip, ()=>{
                if (!skip) {
                    window.dispatchEvent(new Event('resize'));
                    this.introZoomProgress = 0;
                    cb && cb();
                }
            });
        // }

        // console.log('__USE_SCENE__', {name, cb, skip, sceneOptions});

    }

    playIntro(cb) {
    }

    destroy() {
    }

    resize() {

        let w = this.el.clientWidth;
        let h = this.el.clientHeight;

        if (!this.$canvas) return

        this.renderer?.setPixelRatio(PIXEL_RATIO);
        this.renderer?.resize(w, h);
        this.renderPipeline?.resize(w*PIXEL_RATIO, h*PIXEL_RATIO)

        this.camera.aspect = w/h;
        this.camera.updateProjectionMatrix();

        this.operationCamera.aspect = w/h;
        this.operationCamera.updateProjectionMatrix();

        this.focusCamera.aspect = w/h;
        this.focusCamera.updateProjectionMatrix();

        // this.menuCamera.aspect  = w/h;
        // this.menuCamera.updateProjectionMatrix();
    }


    // getMenuUIPositions() {
    //     let screenPositions = {}
    //     let uiArr = this.menuScene.uiElements;
    //     let p = vec3.create()
    //     uiArr.forEach((uiEl)=>{
    //     uiEl.updateMatrix();
    //         uiEl.updateWorldMatrix();
    //         vec3.set(p, uiEl.worldMatrix[12], uiEl.worldMatrix[13], uiEl.worldMatrix[14]);
    //         vec3.transformMat4(p, p, this.menuCamera.inverseWorldMatrix );
    //         vec3.transformMat4(p, p, this.menuCamera.projectionMatrix );
    //         let x = window.innerWidth * .5 + p[0]*window.innerWidth*.5
    //         let y = window.innerHeight * .5 + p[1]*-1*window.innerHeight*.5
    //         screenPositions[uiEl.id] = [x,y, p[2]];
    //     });
    //     return screenPositions
    // }

    getUIPositions() {

        if (!this.loadedScenes[this.currentSceneName]) {
            return []
        }
        
        let screenPositions = {}
        let uiArr = this.loadedScenes[this.currentSceneName].ue4.uiElements;
        let p = vec3.create()
        
        uiArr.forEach((uiEl, i)=>{
            uiEl.updateMatrix();
            uiEl.updateWorldMatrix();
            vec3.set(p, uiEl.worldMatrix[12], uiEl.worldMatrix[13], uiEl.worldMatrix[14]);

            vec3.copy( diff, p );
            vec3.subtract( diff, diff, [ this.currentCamera.worldMatrix[12], this.currentCamera.worldMatrix[13], this.currentCamera.worldMatrix[14] ] )

            let dist = vec3.length( diff )
            vec3.normalize(diff, diff);

            vec3.copy(cameraDir, this.currentCamera.lookAt);
            vec3.subtract(cameraDir, cameraDir, [ this.currentCamera.worldMatrix[12], this.currentCamera.worldMatrix[13], this.currentCamera.worldMatrix[14] ]);
            vec3.normalize(cameraDir, cameraDir);

            if (vec3.dot( cameraDir, diff ) > 0) {
                vec3.transformMat4(p, p, this.currentCamera.inverseWorldMatrix );
                vec3.transformMat4(p, p, this.currentCamera.projectionMatrix );
                let x = window.innerWidth * .5 + p[0]*window.innerWidth*.5
                let y = window.innerHeight * .5 + p[1]*-1*window.innerHeight*.5
                screenPositions[uiEl.id] = [x,y, Math.abs(dist)];
            }
            else {
                screenPositions[uiEl.id] = [-window.innerWidth,0, -1];

            }


        });
        return screenPositions
    }

    updateVideoTextures() {
        if (window.innerWidth > 850) {
            this.lobbyVideos?.forEach( v => {
                if (v._lastTime == void 0 || (v._lastTime != v.video.currentTime) ) {
                    v._lastTime = v.video.currentTime;
                    v?.texture?.bindImage( v.video );
                }
            });
            this.officeVideos?.forEach( v => {
                if (v._lastTime == void 0 || (v._lastTime != v.video.currentTime) ) {
                    v._lastTime = v.video.currentTime
                    v?.texture?.bindImage( v.video )
                }
            });
            this.circularcenterVideos?.forEach( v => {
                if (v._lastTime == void 0 || (v._lastTime != v.video.currentTime) ) {
                    v._lastTime = v.video.currentTime
                    v?.texture?.bindImage( v.video )
                }
            });
            this.quantumroomVideos?.forEach( v => {
                if (v._lastTime == void 0 || (v._lastTime != v.video.currentTime) ) {
                    v._lastTime = v.video.currentTime
                    v?.texture?.bindImage( v.video )
                }
            });
        }
        else {
            this.lobbyVideos?.forEach( v => {
                v?.texture?.bindImage( v.image );
            });
            this.officeVideos?.forEach( v => {
                v?.texture?.bindImage( v.image );
            });
            this.circularcenterVideos?.forEach( v => {
                v?.texture?.bindImage( v.image );
            });
            this.quantumroomVideos.forEach( v => {
                v?.texture?.bindImage( v.image );
            });
        }
    }

    update() {

        
        this.updateVideoTextures();


        debugData.renderPasses = [];


        // if (this.menuParticles) {
        //     // this.menuParticles.useTarget = this.isMenuOpened;
        // }

        // if (this.isMenuOpened) {
        //     settings.uBokehRadius = 2;
        //     this.menuParticles && this.menuParticles.update();
        //     this.renderPipeline && this.renderPipeline.simpleRender();
        //     return;
        // }


        this.cameraProgress = Math.max(0, Math.min(1, this.cameraProgress))

        this.currCameraProgress = this.currCameraProgress || this.cameraProgress
        this.currCameraProgress += (this.cameraProgress - this.currCameraProgress) * 0.1

        if (this.cameraProgress > 0.1 && !document.body.classList.contains('has-scrolled')) {
            document.body.classList.add('has-scrolled')
        }
        if (this.cameraProgress <= 0.1 && document.body.classList.contains('has-scrolled')) {
            document.body.classList.remove('has-scrolled')
        }

        settings.uBokehRadius = 0;

        if (this.currentSceneName === 'lobby' && settings.debugCamera){
            this.camera.position[1] = (200)  * settings.sceneDownscale;
        }

        if (!settings.debugCamera) {

            if (this.currentSceneName === 'exterior'){
                this.homeCamera._cameraDistance = 2000 + 3800 * (1.-this.cameraProgress) + (2000 * (1.-this.introZoomProgress))
                this.homeCamera.offset[0] = -50 + 50 * this.introZoomProgress;
                this.homeCamera.offset[1] = 50 + (1.-this.cameraProgress) * 500
                settings.uBokehRadius = this.cameraProgress * 4;
            }

            if (this.currentSceneName === 'networkroom'){
                this.smoothedProgress = this.cameraProgress;
                this.camera.offset[0] = -200
                this.camera.offset[1] = 200;
                this.camera.offset[2] = -600 + 700 * (1.-this.smoothedProgress)
                this.camera.rotationY =  Math.PI
            }

            if (this.currentSceneName === 'operationroom'){
                this.smoothedProgress = this.cameraProgress;
                this.currentCamera.offset[0] = 1000 * settings.sceneDownscale;
                this.currentCamera.offset[1] = (-300 + 300 * this.smoothedProgress) * settings.sceneDownscale;
                this.currentCamera.offset[2] = (40000 + -50000*this.smoothedProgress) * settings.sceneDownscale;
                this.currentCamera.rotationY = Math.PI + 0.5 + this.cameraRotationY
            }

            if (this.currentSceneName === 'powerroom'){
                this.smoothedProgress = this.cameraProgress;
                this.camera.offset[0] = (700 +  Math.sin(this.smoothedProgress * Math.PI * 2) * 1400)  * settings.sceneDownscale;
                this.camera.offset[1] = (500)  * settings.sceneDownscale;
                this.camera.offset[2] = (Math.cos(this.smoothedProgress * Math.PI * 2) * 800) * settings.sceneDownscale;
                this.camera.rotationY = this.smoothedProgress * Math.PI * 2 + Math.PI + -Math.PI/4 + this.cameraRotationY
            }

            if (this.currentSceneName === 'lobby'){
                this.camera.offset[0] = (500) + this.cameraProgress*-800
                this.camera.offset[1] = (200)
                this.camera.offset[2] = (1000) + this.cameraProgress*-300
                this.camera.rotationY = (Math.PI*1.9-0.3) + this.cameraRotationY  + (this.cameraProgress * Math.PI * -0.3)
            }

            if (this.currentSceneName === 'officeroom'){
                this.officeCamera.offset[0] = 500 +  this.cameraProgress * -300
                this.officeCamera.offset[1] = (200)
                this.officeCamera.offset[2] = (-300) + this.cameraProgress * 800
                this.officeCamera.rotationY = -0.5
            }

            if (this.currentSceneName === 'serverroom'){
                this.smoothedProgress = this.cameraProgress;
                if (this.isInSubRoom) {
                    this.camera.offset[0] = -600  * settings.sceneDownscale
                    this.camera.offset[1] = 200   * settings.sceneDownscale;
                    this.camera.offset[2] = (-900 + this.smoothedProgress  * 1700)  * settings.sceneDownscale;
                    this.camera.rotationY = this.cameraRotationY;
                }
                else {
                    const e       = this.smoothedProgress;
                    const eMove   = Math.min(1, Math.max(0, (e - 0.25) / 0.75));
                    const eRotate = Math.min(1, (Math.sin( Math.min(1,Math.max(0, e / 0.5)) * Math.PI * 2 - Math.PI/2 ) + 1) / 2);
                    this.camera.offset[0] = -150  * settings.sceneDownscale
                    this.camera.offset[1] = 200  * settings.sceneDownscale;
                    this.camera.offset[2] = (-1200 + eMove * 2300)  * settings.sceneDownscale;
                    this.camera.rotationY =  this.cameraRotationY  + (eRotate * Math.PI * -0.25)
                }
            }

            if ( this.currentSceneName === 'innovationroom'){
                this.smoothedProgress = this.cameraProgress
                this.innovationCamera.offset[0] = ((1-this.introZoomProgress) * -150) -350 + 600 * (this.smoothedProgress)
                this.innovationCamera.offset[1] = 150
                this.innovationCamera.rotationY = Math.PI/2 + this.cameraRotationY
            }

            if (this.currentSceneName === 'circularcenter'){
                this.smoothedProgress = this.cameraProgress
                this.circularCenterCamera.offset[0] = 200//-340  + (340 + 188) * this.smoothedProgress
                this.circularCenterCamera.offset[1] = 200 * settings.sceneDownscale;
                this.circularCenterCamera.offset[2] = 600 + -(600 + 1440) * this.smoothedProgress
                this.circularCenterCamera.rotationY = this.cameraRotationY + Math.PI * 0.9// + (this.cameraProgress * -0.7) 
            }

            if (this.currentSceneName === 'quantumroom'){
                this.smoothedProgress = this.cameraProgress;
                const e       = this.smoothedProgress;
                const eMove   = Math.min(1, Math.max(0, (e )  ));
                this.quantumCamera.offset[0] = 70  * settings.sceneDownscale
                this.quantumCamera.offset[1] = 150  * settings.sceneDownscale;
                this.quantumCamera.offset[2] = 2400 - (eMove * 1200);
                this.quantumCamera.rotationY =  this.cameraRotationY  + Math.PI 
            }

        }

        if ( this.currentSceneName == 'lobby' || this.currentSceneName == 'officeroom' || this.currentSceneName == 'circularcenter' || this.currentSceneName == 'quantumroom') {

            if (this.currentSceneName == 'lobby' && this.lobbyVideos.length == 0) {
                this.buildLobbyVideoTexture()
            }

            if (this.currentSceneName == 'officeroom' && this.officeVideos.length == 0) {
                this.buildOfficeVideoTexture()
            }
            
            if (this.currentSceneName == 'circularcenter' && this.circularcenterVideos.length == 0) {
                this.buildCircularCenterVideoTexture()
            }

            if (this.currentSceneName == 'quantumroom' && this.quantumroomVideos.length == 0) {
                this.buildquantumroomVideoTexture()
            }

            if (this.lookAtCameraObjects) {
                this.lookAtCameraObjects.forEach((object, i) => 
                {
                    
                    if (object.children && object.children.length > 0) {
                        object.children.forEach( child => {
                            if (child.uniforms && child.uniforms.tAlbedo) {
                                if (/OFFICE\_PERSON\_/g.test(object.id) ) {
                                    let idx = Number( object.id.replace('OFFICE_PERSON_', '').replace('_Primitive_0','') )
                                    child.uniforms.tAlbedo = this.officeVideos[ idx ].texture
                                }
                                else if (/CIRCULARCENTER\_PERSON\_/g.test(object.id) ) {
                                    let idx = Number( object.id.replace('CIRCULARCENTER_PERSON_', '').replace('_Primitive_0','') )
                                    child.uniforms.tAlbedo = this.circularcenterVideos[ idx ].texture
                                    child.static = false
                                    object.__rot = object.__rot || [object.rotation[0], object.rotation[1], object.rotation[2]]
                                    child.rotation = object.__rot
                                    child.updateMatrix()
                                    child.updateWorldMatrix()
                                }
                                else if (/QUANTUMROOM\_PERSON\_/g.test(object.id) ) {
                                    let idx = Number( object.id.replace('QUANTUMROOM_PERSON_', '').replace('_Primitive_0','') )
                                    child.uniforms.tAlbedo = this.quantumroomVideos[ idx ].texture
                                }
                                else {
                                    child.static = false
                                    child.uniforms.tAlbedo = this.lobbyVideos[0].texture;
                                    object.__rot = object.__rot || [object.rotation[0], object.rotation[1], object.rotation[2]]
                                    child.rotation = object.__rot
                                    child.updateMatrix()
                                    child.updateWorldMatrix()
                                }
                            }
                        })
                    }

                    if (object.uniforms && object.uniforms.tAlbedo) {
                        if (/OFFICE\_PERSON\_/g.test(object.id) ) {
                            let idx = Number( object.id.replace('OFFICE_PERSON_', '').replace('_Primitive_0','') )
                            object.uniforms.tAlbedo = this.officeVideos[ idx ].texture
                        }
                        else if (/CIRCULARCENTER\_PERSON\_/g.test(object.id) ) {
                            let idx = Number( object.id.replace('CIRCULARCENTER_PERSON_', '').replace('_Primitive_0','') )
                            object.uniforms.tAlbedo = this.circularcenterVideos[ idx ].texture
                            object.static      = false
                            object.__rot       = object.__rot || [object.rotation[0], object.rotation[1], object.rotation[2]]
                            object.rotation[0] = 0
                            object.rotation[1] = 0
                            if (/CIRCULARCENTER\_PERSON\_0/g.test(object.id)) object.rotation[2] = this.cameraProgress * (Math.PI/-2 * 1.5) + Math.PI/3
                            if (/CIRCULARCENTER\_PERSON\_1/g.test(object.id)) object.rotation[2] = this.cameraProgress * Math.PI/-2
                            if (/CIRCULARCENTER\_PERSON\_2/g.test(object.id)) object.rotation[2] = this.cameraProgress * (Math.PI/2 * 1.5) - Math.PI/2
                            if (/CIRCULARCENTER\_PERSON\_3/g.test(object.id)) object.rotation[2] = this.cameraProgress * Math.PI/2
                            object.updateMatrix()
                            object.updateWorldMatrix()
                        }

                        else if (/QUANTUMROOM\_PERSON\_/g.test(object.id) ) {
                            let idx = Number( object.id.replace('QUANTUMROOM_PERSON_', '').replace('_Primitive_0','') )
                            object.uniforms.tAlbedo = this.quantumroomVideos[ idx ].texture
                            object.static      = false
                            object.__rot       = object.__rot || [object.rotation[0], object.rotation[1], object.rotation[2]]
                            object.rotation[0] = 0
                            object.rotation[1] = 0
                            if (/QUANTUMROOM\_PERSON\_0/g.test(object.id)) object.rotation[2] =  this.cameraProgress * -(Math.PI * 0.6);  
                            if (/QUANTUMROOM\_PERSON\_1/g.test(object.id)) object.rotation[2] =  this.cameraProgress * -(Math.PI * 0.6);
                            console.log('ROTATE PERSON 4', object.rotation[2])
                            object.updateMatrix()
                            object.updateWorldMatrix()
                        }
                        else {
                            object.static      = false
                            object.uniforms.tAlbedo = this.lobbyVideos[0].texture;
                            object.__rot       = object.__rot || [object.rotation[0], object.rotation[1], object.rotation[2]]
                            object.rotation[0] = 0
                            object.rotation[1] = 0
                            object.rotation[2] = this.cameraProgress * -Math.PI/2
                            object.updateMatrix()
                            object.updateWorldMatrix()
                        }
                    }

                })
            }
        }

        if (this.data.playing) {
            this.renderPipeline?.render();
        }

    }

}